<template>
  <div class="col-sm-12">
    <br />
    <br />
    <h3>Deleting individual and all pending changes</h3>
    <table>
      <tbody>
        <tr>
          <td>
            <p class="note">
              You can delete any individual record from the preview or edit screens. However, if you have a
              <em>LOT</em> of editing to do, you might consider deleting all your uploaded changes and starting over - editing the upload file to
              correct the problems first. The tool is designed to upload a lot of records, make some minor changes to individual records using the
              "edit" button and then finalize the changes. It is <em>not</em> designed for wholesale editing. <br />
              <br />
              To delete all of your pending records (all uploaded records are considered "pending" till finalized), click on
            </p>
            <div><input type="button" value="delete pending changes" class="btn btn-primary btn-lg btn-sm-block mr-2" /></div>
            <br />
            <p class="note">
              at the bottom. all pending records will be deleted.<br />
              <br />
            </p>
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <br />
  </div>
</template>
<script>
export default {
  name: 'Delete',
};
</script>
<style scoped>
table {
  border: 0px solid transparent;
  font-size: 14px;
  width: inherit;
}
fieldset {
  padding: 0.35em 0.625em 0.75em;
  margin: 0 5px;
  border: 1px solid silver;
  border-radius: 8px;
}
legend {
  width: auto;
  padding: 10px;
  font-size: 15px;
  color: #333;
  border: 0;
  border-bottom: none;
}
</style>
